import { render, staticRenderFns } from "./viewChange.vue?vue&type=template&id=5d516048&scoped=true&"
import script from "./viewChange.vue?vue&type=script&lang=js&"
export * from "./viewChange.vue?vue&type=script&lang=js&"
import style0 from "./viewChange.vue?vue&type=style&index=0&id=5d516048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d516048",
  null
  
)

export default component.exports